import React, { useEffect, useState } from "react";
import { Newspaper, ExternalLink } from "lucide-react";
import api from "../lib/api";

const CATEGORIES = [
  { id: "forex", label: "Forex" },
  { id: "general", label: "Generale" },
  { id: "crypto", label: "Crypto" },
  { id: "merger", label: "M&A" },
];

const fmtTime = (ts) =>
  ts ? new Date(ts * 1000).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "";

export function MarketNews() {
  const [category, setCategory] = useState("forex");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/news/finnhub?category=${category}`)
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <div className="mt-16" data-testid="news-section">
      <div className="mb-6">
        <span className="inline-flex items-center gap-2 text-xs font-mono px-3 py-1 rounded-full bg-blue-500/15 text-blue-400 border border-blue-500/20 mb-4">
          <Newspaper size={12} /> NEWS
        </span>
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">News di Mercato</h2>
        <p className="text-zinc-400 mt-2">Notizie in tempo reale su forex, oro e criptovalute.</p>
      </div>

      <div className="flex flex-wrap gap-2 mb-6">
        {CATEGORIES.map((c) => (
          <button key={c.id} data-testid={`news-cat-${c.id}`} onClick={() => setCategory(c.id)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors border ${category === c.id ? "bg-blue-600 text-white border-blue-500" : "bg-white/5 text-zinc-300 border-white/10 hover:bg-white/10"}`}>
            {c.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-center py-20 text-zinc-500" data-testid="news-loading">Caricamento…</div>
      ) : items.length === 0 ? (
        <div className="text-center py-20 text-zinc-500 border border-dashed border-white/10 rounded-md" data-testid="news-empty">Nessuna notizia al momento.</div>
      ) : (
        <div className="space-y-3">
          {items.map((n) => (
            <div key={n.id} data-testid={`news-item-${n.id}`} className="bg-[#141414] border border-white/10 rounded-md p-4 flex gap-4 hover:border-white/20 transition-colors">
              {n.image ? <img src={n.image} alt="" className="w-28 h-20 object-cover rounded shrink-0 hidden sm:block" /> : null}
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 text-[11px] text-zinc-500 mb-1">
                  <span className="font-mono uppercase text-blue-400">{n.source}</span> · {fmtTime(n.datetime)}
                </div>
                <h3 className="text-sm font-semibold text-white leading-snug">{n.headline}</h3>
                {n.summary && <p className="text-xs text-zinc-400 mt-1 line-clamp-2">{n.summary}</p>}
                {n.url && (
                  <div className="mt-2.5">
                    <a href={n.url} target="_blank" rel="noopener noreferrer" data-testid={`news-read-${n.id}`}
                      className="inline-flex items-center gap-1 text-[11px] text-zinc-400 hover:text-white transition-colors">
                      Leggi <ExternalLink size={11} />
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function News() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-10" data-testid="news-page">
      <MarketNews />
    </div>
  );
}
